import { useQuery } from '@apollo/client/react';
import { DatePicker } from '@optools/components/datetime/date-picker';
import { GameSchedule } from '@optools/components/game-schedule';
import { dateSchema } from '@optools/schemas/date';
import { GET_SCHEDULE } from '@optools/services/operator-gateway/audit/queries';
import { Sport } from '@optools/services/operator-gateway/types/generated/graphql';
import { AuditGameCard } from '@optools/tools/audit/components/audit-game-card';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_auth/audit/schedule')({
  component: RouteComponent,
  validateSearch: zodValidator(dateSchema),
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/audit/schedule' });
  const navigate = useNavigate({ from: Route.fullPath });
  const handleDateChange = (newDate: string) => {
    return navigate({ search: (search) => ({ ...search, date: newDate }) });
  };

  const { data, loading } = useQuery(GET_SCHEDULE, {
    fetchPolicy: 'network-only',
    variables: { date, sports: [Sport.MLB] },
  });

  return (
    <GameSchedule
      loading={loading}
      render={(game) => <AuditGameCard key={game.gamePk} game={game} />}
      schedule={data?.schedule}>
      <DatePicker date={date} setDate={handleDateChange} />
    </GameSchedule>
  );
}
